import { useEffect, useState } from "react";
import { admin, getToken, setToken } from "@/lib/admin";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

export default function Admin() {
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    document.title = "Leads — Bossard Investment Group";
    if (!getToken()) return setAuthed(false);
    admin
      .get("/auth/me")
      .then(() => setAuthed(true))
      .catch(() => {
        setToken(null);
        setAuthed(false);
      });
  }, []);

  if (authed === null) return <div className="min-h-screen" data-testid="admin-checking" />;
  return authed ? <AdminDashboard onLogout={() => setAuthed(false)} /> : <AdminLogin onSuccess={() => setAuthed(true)} />;
}
